// @flow

import React from 'react';

import ContentList from 'app/common/components/ContentList';
import Modal from 'app/common/components/Modal';
import ScrollableBox from 'app/common/components/ScrollableBox';
import InfoBlock, { InfoBlockTitle } from 'app/common/components/InfoBlock';

type FailedZap = {
  id?: number, // Ideally exists, but cases where it might not
  message: string,
  title?: string, // Ideally exists, but cases where it might not
};

type ZapImportErrorsModalProps = {
  failedZaps: FailedZap[],
  onClose: () => void,
};

const ZapImportErrorsModal = (props: ZapImportErrorsModalProps) => {
  return (
    <Modal
      closeOnEsc={true}
      closeOnOutsideClick={true}
      contentClassName=""
      isOpened={true}
      kind="narrow"
      onClose={props.onClose}
    >
      <InfoBlock kind="bare">
        <InfoBlockTitle>These Zaps failed to import</InfoBlockTitle>
        <ScrollableBox kind="padded bordered" maxHeight={230}>
          <ContentList kind="marginless indented">
            {props.failedZaps.map((zap, idx) => (
              <li key={zap.id || idx}>
                {zap.title && <strong>{zap.title}:</strong>} {zap.message}
              </li>
            ))}
          </ContentList>
        </ScrollableBox>
      </InfoBlock>
    </Modal>
  );
};

export default ZapImportErrorsModal;
